import { Tooltip } from '@scuf/common';
import React, { FC } from 'react';
import { ACTION_TRACKING_STATUS } from '../../constants/constants';
import BlueTick from '../../images/blue-tick.svg';
import GrayTick from '../../images/gray-tick.svg';
import RedTick from '../../images/red-tick.svg';
import YellowTick from '../../images/yellow-tick.svg';

interface TooltipRendererProps {
    content: string;
    imgUrl: string;
}

const TooltipRenderer: FC<TooltipRendererProps> = ({content, imgUrl}) => {
     return <Tooltip
     content={content}
     element={
         <img src={imgUrl} alt="tick icon"/>
     }
     position="right center"
     event="hover"
     hoverable={true}
 />;
 };

const ActionTrackingStatusCellRenderer = (params: any) => {
    const status = params.data.tracking_status;
    return <>
    {status ===  ACTION_TRACKING_STATUS.INCOMPLETE && <TooltipRenderer imgUrl={RedTick} content="Task is not completed." /> }
    {status ===  ACTION_TRACKING_STATUS.PARTIALLY_COMPLETE && <TooltipRenderer imgUrl={YellowTick} content="Assigned tasks partially completed, please check review task log" />}
    {status ===  ACTION_TRACKING_STATUS.ALL_COMPLETE && <TooltipRenderer imgUrl={GrayTick} content="All actions marked completed" />}
    {status ===  ACTION_TRACKING_STATUS.ORG_USER_COMPLETE && <TooltipRenderer imgUrl={BlueTick} content="The anomaly marked completed by Org Owner." />}</>;
};

export default ActionTrackingStatusCellRenderer;
